import { FileServiceResponse } from '../interfaces/files-cache.interface';
import { FILESCACHE_KEYS } from '../enums/files-cache.enum';
import { BackupFileServices } from '@/core/services/backup.file.services';

declare const window: any;

export class ElectronLocalFileSystemService {

  async getFile(filename: string): Promise<FileServiceResponse> {
    try {
      let fileData = await window.electronAPI.getCacheFile(filename);
      if (fileData) {
        return { result: true, file: new Blob([fileData], { type: 'application/pdf' }) };
      }
      return { result: false };
    } catch (error) {
      BackupFileServices.eduacCustomErrorHandler({ promiseRejectionEvent: error });
      return { result: false, error };
    }
  }

  async saveFile(filename: string, data: any) {
    try {
      await window.electronAPI.cacheFile(filename, data);
      return { result: true };
    } catch (error) {
      BackupFileServices.eduacCustomErrorHandler({ promiseRejectionEvent: error });
      return { result: false, error };
    }
  }

  async removeExpiredFiles() {
    try {
      window.electronAPI.removeExpiredFiles(FILESCACHE_KEYS.STORE_EXP_TIME);
    } catch (error) {
      BackupFileServices.eduacCustomErrorHandler({ promiseRejectionEvent: error });
    }
  }
}